import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {BaseModalComponent} from "../base-modal/base-modal.component";
import {bankDetailsResourceType} from "./configs/bank-details-modal-config";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {SelectData} from "../../../types/records-table.types";
import {
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {BankDetailsModalService} from "./services/bank-details-modal.service";
import {BankDetailsDialogData} from "./types/bank-details-modal.types";
import {LoadingService} from "../../../services/loading.service";
import {
  CurrentBankDetailsComponent
} from "./components/current-bank-details/current-bank-details.component";
import {
  NewBankDetailsComponent
} from "./components/new-bank-details/new-bank-details.component";
import {customDateProvider} from "../../../locale/providers/custom-date.provider";
import {LoaderComponent} from "../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-bank-details-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CurrentBankDetailsComponent,
    NewBankDetailsComponent,
    LoaderComponent
  ],
  providers: [ ...customDateProvider, LoadingService ],
  templateUrl: './bank-details-modal.component.html',
  styleUrls: [
    './bank-details-modal.component.scss',
    '../base-modal/base-modal.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankDetailsModalComponent extends BaseModalComponent {
  public bankDetailsDialogData = inject<BankDetailsDialogData>(MAT_DIALOG_DATA);
  private bankDetailsService: BankDetailsModalService = inject(BankDetailsModalService);

  public readonly bankDetailsResourceType = bankDetailsResourceType;
  public legalEntityTypes = signal<Array<SelectData>>([]);
  public bankDetailsValid = signal<boolean>(false);

  public override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    await this.initModal();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(bankDetailsResourceType.path);
  }

  public async handleButtonClick(bankDetailsId: number | null): Promise<void> {
    this.bankDetailsDialogData.recordData['bankDetails'] = this.bankDetailsService.updateBankDetailsToTable(bankDetailsId, this.bankDetailsDialogData.recordData);
    this.bankDetailsValid.set(bankDetailsId !== null);
  }

  private async initModal(): Promise<void> {
    this.modalStatesService.openModal(bankDetailsResourceType.path);
    this.bankDetailsValid.set(this.baseModalService.isModalValid(this.bankDetailsDialogData.recordData, 'bankDetails'));
    this.loadingService.setIsLoadingState(true);
    await this.getLegalEntityTypes();
  }

  private async getLegalEntityTypes(): Promise<void> {
    await this.bankDetailsService.getSelectData(Number(this.bankDetailsDialogData.recordData?.id))
      .then((data) => this.legalEntityTypes.set(data))
      .catch(() => [])
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
